import { handleActions } from 'redux-actions';
import * as types from './types';

const initialState = {
  data: {},
  error: null,
  initialLoad: false,
  loading: false,
  saving: false,
};

const getDataSourcesRequest = (state) => {
  return {
    ...state,
    error: null,
    loading: true,
  };
};
const getDataSourcesRequestFailure = (state, action) => {
  return {
    ...state,
    data: {},
    error: action.error,
    loading: false,
  };
};
const getDataSourcesRequestSuccess = (state, payload) => {
  return {
    ...state,
    data: payload.data,
    error: null,
    initialLoad: true,
    loading: false,
  };
};

const updateDataSourcesRequest = (state) => {
  return {
    ...state,
    error: null,
    saving: true,
  };
};
const updateDataSourcesRequestFailure = (state, action) => {
  return {
    ...state,
    error: action.error,
    saving: false,
  };
};
const updateDataSourcesRequestSuccess = (state, payload) => {
  const data = { ...state.data, chromeExtension: 'chrome_ext_good' };
  return {
    ...state,
    data,
    error: null,
    saving: false,
  };
};

export default handleActions(
  {
    [types.GET_DATASOURCES_REQUEST]: getDataSourcesRequest,
    [types.GET_DATASOURCES_REQUEST_FAILURE]: getDataSourcesRequestFailure,
    [types.GET_DATASOURCES_REQUEST_SUCCESS]: getDataSourcesRequestSuccess,
    [types.UPDATE_DATASOURCES_REQUEST]: updateDataSourcesRequest,
    [types.UPDATE_DATASOURCES_REQUEST_FAILURE]: updateDataSourcesRequestFailure,
    [types.UPDATE_DATASOURCES_REQUEST_SUCCESS]: updateDataSourcesRequestSuccess,
  },
  initialState
);
